export default {"src":"/_next/static/media/numpy.0fd80405.svg","height":274,"width":256,"blurWidth":0,"blurHeight":0};